import Model from 'core/model/Model';
import { computed } from 'mobx';

export default class AlertStatsModel extends Model {
  @computed
  get totalCount() {
    return Object.values(this.get('severities')).reduce((acc, val) => acc + val, 0);
  }
}
